import { FeatureKey } from 'common/utils';

import type { RootState } from 'store';

export const selectIsDarkTheme = (state: RootState) => state.app.darkTheme;
export const selectScrollToTop = (state: RootState) => state.app.scrollToTop;
export const selectIsDrawerDisplayed = (state: RootState) => state.app.displayDrawer;
export const selectMobileMenuOpen = (state: RootState) => state.app.mobileMenuOpen;
export const selectMobileBroadcastDrawerOpen = (state: RootState) => state.app.mobileBroadcastDrawerOpen;
export const selectIsDrawerCollapsed = (state: RootState) => state.app.isDrawerCollapsed;
export const selectIsFeatureEnabled = (state: RootState, feature: FeatureKey) => state.app.features[feature];
